import { render, staticRenderFns } from "./give.vue?vue&type=template&id=33fcbe28&scoped=true&"
import script from "./give.vue?vue&type=script&lang=js&"
export * from "./give.vue?vue&type=script&lang=js&"
import style0 from "./give.vue?vue&type=style&index=0&id=33fcbe28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fcbe28",
  null
  
)

export default component.exports